const parseStringToBoolean = (string) =>
  string && string.toLowerCase() === 'true'

export default {
  dateFormat: 'MM/DD/YYYY',
  enableChangePlan: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_CHANGE_PLAN,
  ),
  enableDowngradePlan: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_DOWNGRADE_PLAN,
  ),
  enableRestrictPlace: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_RESTRICT_PLACE,
  ),

  gracePeriod: 3,
  expiresPlanInDay: 14,
  minimumDayDisplayRecurringNotificationMonthly: 3,
  minimumDayDisplayRecurringNotificationAnnual: 30,
  limitOverdraftPercent: 10,
  isMembershipCardEnabled: true,
  isSocialPostingEnabled:
    parseStringToBoolean(process.env.REACT_APP_SOCIAL_POSTING_ENABLED) || false,
}
